var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClass},[_c('h3',{class:_vm.animationClass},[_vm._v(_vm._s(_vm.personalizedMessages[_vm.counter]))])])}
var staticRenderFns = []

export { render, staticRenderFns }